import React from 'react'
import Hero from '../components/Hero'
import WhySell from '../components/WhySell'
import VerifyAccount from '../components/VerifyAccount'
import Benefits from '../components/Benefits'
import GetFeatured from '../components/GetFeatured'
import ToolsTeam from '../components/ToolsTeam'
import Share from '../components/Share'
import FAQ from '../components/FAQ'
import BottomHero from '../components/BottomHero'
import Carousel from '../components/Carousel'
import Support from '../components/Support'
import { Layout } from '../components/styles'

const AppLayout = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <Layout>
      <Hero />
      <WhySell />
      <VerifyAccount />
      <Carousel />
      <Benefits />
      <GetFeatured />
      <Support />
      <ToolsTeam />
      <Share />
      <FAQ />
      <BottomHero />
    </Layout>
  )
}

export default AppLayout